import { StorageService } from '../services/StorageService';
import { IImportLeadPayload } from '../types/api';

import { getUrlParameters } from './url';

export const getPersistedUrlParameters = (
  params?: Partial<IImportLeadPayload> & Record<string, unknown>,
) => {
  const currentParams = getUrlParameters();
  const savedPrams = StorageService.fromStorage(
    'url_params',
    undefined,
    sessionStorage,
  );

  delete currentParams['token'];
  delete currentParams['ba_token'];
  delete currentParams['errorMsg'];
  delete currentParams['cancel_url'];
  delete currentParams['paypalAccept'];

  const mergedParams = {
    ...savedPrams,
    ...currentParams,
  };
  if (params?.orderId) {
    mergedParams.prospect_id = params.orderId;
    mergedParams.order_id = params.orderId;
  }
  if (params?.sessionId) {
    mergedParams.session_id = params.sessionId;
  }
  if (params?.customerId) {
    mergedParams.customer_id = params.customerId;
  }
  if (params?.pid) {
    mergedParams.pid = params.pid;
  }

  StorageService.toStorage('url_params', mergedParams, sessionStorage);
  return Object.values(mergedParams).length > 0
    ? new URLSearchParams(mergedParams).toString()
    : '';
};

export const navigate = (
  urlPath: string,
  lead?: Partial<IImportLeadPayload>,
  params?: Record<string, string>,
) => {
  let route = window.location.origin;
  if (urlPath.startsWith('/')) {
    route += urlPath;
  } else {
    route += `/${urlPath}`;
  }
  const urlParams = getPersistedUrlParameters({
    ...lead,
    ...params,
  });
  console.log(urlParams);
  window.location.href = urlParams ? `${route}?${urlParams}` : route;
};

export const isCheckoutPage = () => {
  const pathname = window.location.pathname;
  return pathname.includes('products-order') && !window.IS_1_CLICK;
};

export const isOneClickPage = () => {
  const pathname = window.location.pathname;
  return pathname.includes('click-order');
};

export const isOneClickCheckoutPage = () => {
  const pathname = window.location.pathname;
  return pathname.includes('products-order') && window.IS_1_CLICK;
};

export const isSuccessPage = () => {
  const pathname = window.location.pathname;
  return pathname.includes('thank-you');
};

export const isUpsellPage = (no?: number) => {
  const pathname = window.location.pathname;
  if (typeof no === 'number') {
    return pathname.includes(`promo-order-${no}`);
  } else {
    return pathname.includes('promo-order-');
  }
};
